import { createRoot } from "@wordpress/element";
import AIResponseTopic from "./ai-response-to-topic";
import { $, OPTIONS } from "../utils/constants";
import { sleep } from "../utils/sleep";

document.addEventListener("DOMContentLoaded", () => {
    const $container = $(".bbp-topic-form");
    const $form = $container?.find<HTMLFormElement>("form#new-post");
    const $submitBtn = $form?.find("#bbp_topic_submit");

    const $modal = $("<div></div>");
    $container?.append($modal);

    $form?.on("submit", async function (e) {
        if (!OPTIONS.AI_RESPONSE_TO_TOPIC) return;

        e.preventDefault();
        await sleep(100);

        createRoot($modal[0]).render(<AIResponseTopic form={this} />);
    });
});
